import { Artifact, FormValues } from './types';

/**
 * Only the first artifact is editable in the wizard, but a workflow created
 * through the API can carry more — they must survive an update untouched.
 */
export function updateFirstArtifact(
  values: FormValues,
  changes: Partial<Artifact>
): FormValues {
  return {
    ...values,
    artifacts: values.artifacts.map((artifact, index) =>
      index === 0 ? { ...artifact, ...changes } : artifact
    ),
  };
}
